/**
 * TEMPORARY — Supabase integration smoke check. Delete once the real login
 * flow consumes the client.
 *
 * Exercises the real shared client on every platform (iOS / Android / web):
 *  1. the client module initializes without throwing
 *  2. the storage adapter round-trips through getSession()
 *  3. crypto.getRandomValues is available (required for PKCE later)
 *
 * No network involved: the config still points at placeholder values and
 * getSession() only reads local storage.
 */
import { STAGE } from 'config/envVars';

import { getSupabaseClient } from './client';

try {
  const client = getSupabaseClient();

  const hasGetRandomValues =
    typeof globalThis.crypto?.getRandomValues === 'function';

  client.auth
    .getSession()
    .then(({ data, error }) => {
      // eslint-disable-next-line no-console
      console.log(
        `[SUPABASE SMOKE] OK — env: ${STAGE}, ` +
          `auth: ${!!client.auth}, ` +
          `getSession: ${error ? `error(${error.message})` : 'ok'}, ` +
          `session: ${
            data?.session === null ? 'null (expected)' : 'present'
          }, ` +
          `crypto.getRandomValues: ${hasGetRandomValues}`
      );
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.error('[SUPABASE SMOKE] getSession FAILED:', e);
    });
} catch (e) {
  // eslint-disable-next-line no-console
  console.error('[SUPABASE SMOKE] client initialization FAILED:', e);
}
